import React from "react";

import { useFormikContext } from "formik";

import Row from "../shared/Row";
import CardPanel from "../shared/CardPanel";
import CardHeader from "../shared/CardHeader";
import InputField from "../shared/InputField";

export default function Notes() {
  const {
    values: { notes },
  } = useFormikContext();

  return (
    <CardPanel>
      <CardHeader text="Notes" icon="note" />
      <Row>
        <InputField name="notes" size="s12">
          <div className="helper-text">{notes.length} characters</div>
        </InputField>
      </Row>
    </CardPanel>
  );
}
